import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { replacePattern } from './replacePattern';
import { round } from './round';
import { SEPARATORS } from '../constants';

/**
 * Additional options for formatting the value.
 *
 * @property {string} negativePattern custom formatting pattern for negative values (e.g. "-n", "n-")
 * @property {boolean} removeTrailingZeros if true, decimal zeros are not displayed (e.g. "1.20" -> "1.2")
 */

// eslint-disable-next-line max-params -- needed for formatting
export function formatNumberExplicitly(value, decimals, decimalSeparator, groupSizes, groupSeparator, options) {
  var formattedValue = '';
  var isNegative = false;
  var absValue = value;

  // Note: standard JS rounding
  // If the fractional portion is exactly 0.5, the argument is rounded to the next integer in the direction of +∞.
  // This differs from many languages' round() functions, which often round half-increments away from zero.
  // Because of this difference, the absolute value is used and the negative sign is added at the end, so it is compatible with BE!

  // negative to positive
  if (value < 0) {
    isNegative = true;
    absValue = Math.abs(value);
  }

  // round
  var roundedValue = round(absValue, decimals);

  // split to integer and fraction parts
  var _roundedValue$toFixed = roundedValue.toFixed(decimals).split(SEPARATORS.DOT),
    _roundedValue$toFixed2 = _slicedToArray(_roundedValue$toFixed, 2),
    integerString = _roundedValue$toFixed2[0],
    fractionString = _roundedValue$toFixed2[1];

  // split into groups
  var maxIndex = integerString.length - 1;
  var groupSize = groupSizes[0]; // this simplifies a lot!
  var groupIteration = 0;
  var totalIndex = 0;
  do {
    totalIndex = groupIteration * groupSize;
    for (var i = 0; i < groupSize; i++) {
      if (totalIndex <= maxIndex) {
        formattedValue = integerString.charAt(maxIndex - totalIndex) + formattedValue;
        totalIndex += 1;
      }
    }
    if (totalIndex <= maxIndex) {
      formattedValue = groupSeparator + formattedValue;
    }
    groupIteration += 1;
  } while (totalIndex <= maxIndex);

  // append fraction
  if (fractionString) {
    var fractionStringValue = fractionString;
    // remove trailing zeros if needed
    if (options !== null && options !== void 0 && options.removeTrailingZeros) {
      fractionStringValue = fractionString.replace(/0+$/, '');
    }
    if (fractionStringValue.length > 0) {
      formattedValue += decimalSeparator + fractionStringValue;
    }
  }

  // add negative symbol
  if (options !== null && options !== void 0 && options.negativePattern && isNegative) {
    formattedValue = replacePattern(options.negativePattern, {
      n: formattedValue
    });
  }

  // formattedValue = spacesToNonBreakingSpaces(formattedValue);

  return formattedValue;
}